import styled from 'styled-components';
import { minBp } from 'src/lib/theme';
import { buttonStyles } from 'components/Button/Button';

export const Wrap = styled.div`
  padding: 55px 30px 30px;

  @media ${minBp('tablet')} {
    padding: 75px 60px 60px;
    width: 650px;
  }

  @media ${minBp('tabletLarge')} {
    width: 800px;
  }
`;

export const H4 = styled.h4`
  text-transform: uppercase;
  margin-bottom: 7px;
`;

export const SubTitle = styled.p`
  margin-bottom: 10px;
  color: #000;
  font-size: 13px;
  line-height: 19px;

  @media ${minBp('desktop')} {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const ResetButton = styled.button`
  ${buttonStyles}
`;

export const ResetButtonWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  ${({ $vertical }) =>
    $vertical &&
    `
      flex-direction: column;
      align-items: start;
    `}

  @media ${minBp('tabletLarge')} {
    margin-top: 14px;
  }

  ${ResetButton} {
    width: auto;
    min-width: ${({ $vertical }) => ($vertical ? '20rem' : '126px')};
    margin-bottom: ${({ $vertical }) => ($vertical ? '0.75rem' : '17px')};
    margin-right: 8px;
    cursor: pointer;

    @media ${minBp('tabletLarge')} {
      min-width: ${({ $vertical }) => ($vertical ? '20rem' : '200px')};
      margin-right: 15px;
    }

    &:last-child {
      margin-right: 0;
      margin-bottom: 0;
    }
  }
`;

export const MainText = styled.p`
  color: #585a5f;
  font-size: 12px;
  line-height: 19px;
  margin: 0;

  @media ${minBp('desktop')} {
    font-size: 14px;
    line-height: 22px;
  }
`;
